import CartConf, { routeOptionsMapper } from "./conf.mjs";
export function resolveCartOptions(operation) {
  return CartConf[operation] ?? {};
}
export function resolveCartRouteOptions(operation, name) {
  return routeOptionsMapper[name?.toString().split("___")[0] || ""]?.[operation] ?? {};
}
export function mapStoreLocatorToCartAddressInput(storeLocator) {
  return {
    street: [storeLocator.address],
    city: storeLocator.city?.code || "",
    // district: storeLocator.district?.code as string,
    region: storeLocator.region?.code,
    country_code: "EG",
    firstname: "Store pickup",
    lastname: storeLocator.name || "",
    save_in_address_book: false,
    telephone: storeLocator?.phone_number,
    postcode: "12345"
  };
}
export function resolveCartItemPrice(apiProduct) {
  if (["BundleProduct", "ConfigurableProduct", "GroupedProduct"].includes(
    apiProduct.__typename
  )) {
    return apiProduct.only_x_left_in_stock === null ? 1e4 : apiProduct.only_x_left_in_stock;
  }
  return apiProduct.only_x_left_in_stock || 0;
}
export function resolveGiftOptionId(apiProduct) {
  if (apiProduct.__typename === "SimpleCartItem" && apiProduct.product.__typename === "SimpleProduct") {
    return apiProduct.product?.options?.find(
      (option) => option?.__typename === "CustomizableFieldOption"
    )?.option_id;
  }
  if (apiProduct.__typename === "ConfigurableCartItem" && apiProduct.product?.__typename === "ConfigurableProduct") {
    return apiProduct.product?.options?.find(
      (option) => option?.__typename === "CustomizableFieldOption"
    )?.option_id;
  }
  return null;
}
export function resolveGiftMessage(apiProduct) {
  if (apiProduct.__typename === "SimpleCartItem" && apiProduct.product.__typename === "SimpleProduct") {
    return apiProduct.customizable_options[0]?.values[0]?.value;
  }
  if (apiProduct.__typename === "ConfigurableCartItem" && apiProduct.product?.__typename === "ConfigurableProduct") {
    return apiProduct?.customizable_options?.[0]?.values[0]?.value;
  }
  return null;
}
